module.exports = __webpack_public_path__ + "media/images/locations/liestal-map-839d0d3c164670578777bb6cfe1c1bbf.jpg";